module.exports = __webpack_public_path__ + "img/logo-king.cbea48fe.png";